"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maskEmail = exports.loadFooterWF = exports.loadNavigationWF = undefined;

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dynamically loads a Web Framework Components script and waits until the custom element is defined.
 *
 * @param {string} brand - The brand for WF Component (e.g. "quixel", "epicgames" etc)
 * @param {string} type - The WF Component type (e.g. "footer", "navigation" etc)
 * @returns {Promise<void>} A promise that resolves once the element is defined and ready to use.
 *
 * @example
 * await loadWebComponent("quixel", "navigation");
 * document.body.appendChild(document.createElement('quixel-navigation'));
 */
function loadWebComponent(brand, type) {
  var isSSR = typeof window === "undefined" || typeof document === "undefined" || !__CLIENT__;
  if (isSSR) {
    return _promise2.default.resolve();
  }
  var tag = brand + "-" + type;
  var url = _config2.default.wfComponentsUrl + "/" + type + "/" + tag + ".mjs";
  return new _promise2.default(function (resolve, reject) {
    if (customElements.get(tag)) return resolve();
    if (document.querySelector("script[src=\"" + url + "\"]")) {
      return customElements.whenDefined(tag).then(resolve).catch(reject);
    }
    var s = document.createElement("script");
    s.src = url;
    s.type = "module";
    s.onload = function () {
      return customElements.whenDefined(tag).then(resolve).catch(reject);
    };
    s.onerror = reject;
    document.body.appendChild(s);
  });
}

var loadNavigationWF = exports.loadNavigationWF = function loadNavigationWF() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config2.default.wfComponentsNavigationBrand;

  if (!brand) {
    console.error("[loadNavigationWF] Was called with empty brand");
    return;
  }
  return loadWebComponent(brand, "navigation");
};

var loadFooterWF = exports.loadFooterWF = function loadFooterWF() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config2.default.wfComponentsFooterBrand;

  if (!brand) {
    console.error("[loadFooterWF] Was called with empty brand");
    return;
  }
  return loadWebComponent(brand, "footer");
};

var valueMaskRegex = /^([^\\x00-\\x7F]|\w)(.*?)([^\\x00-\\x7F]|\w)$/;
/**
 * Masks email string
 *
 * @param {string} unmaskedEmail - Original email string to be masked
 * @returns {string} Masked email string
 *
 * @example
 * maskEmail("john.doe@example.com"); // "j***e@example.com"
 */
var maskEmail = exports.maskEmail = function maskEmail(unmaskedEmail) {
  if (!unmaskedEmail || !unmaskedEmail.includes("@")) {
    return unmaskedEmail;
  }

  var _unmaskedEmail$split = unmaskedEmail.split("@"),
      _unmaskedEmail$split2 = (0, _slicedToArray3.default)(_unmaskedEmail$split, 2),
      emailId = _unmaskedEmail$split2[0],
      emailDomain = _unmaskedEmail$split2[1];

  if (!emailId || !emailDomain) {
    console.warn("[maskEmail] did not receive a valid email");
    return unmaskedEmail;
  }

  var maskedEmailId = emailId.replace(valueMaskRegex, "$1***$3");
  return maskedEmailId + "@" + emailDomain;
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/navigationUtils.js
// module id = 1163
// module chunks = 0